import {
  LeadSystemSource,
  ProgramType,
  scheduleClient,
  SchedulingWorkflow,
  Step,
  User,
} from '@enaratech/funnel-helper';
import { Dispatch } from 'react';
import Toast from 'src/components/Common/Toast/Toast';
import { ClinicState } from 'src/contexts/clinic/types';
import {
  RecentlyBookedAppointments,
  SET_SSB_INFO,
  SSBActionTypes,
  SSBFlowState,
} from 'src/contexts/ssb/types';
import { capitalizeToKebabCase } from 'src/utils/array';
import { getEffectiveProgramType } from 'src/utils/programType';
import { reconcileStepsWithRecentBookings } from '../../appointments';
import { getPreviousAppointmentByRules } from './fetchStatusAction';

export const goToNextStepAction = async ({
  context,
  setState,
}: {
  context: {
    stepsRef: React.MutableRefObject<Step[] | null>;
    scheduledAppointments: any;
    recentlyBookedAppointments: RecentlyBookedAppointments;
    user: User;
    clinic: ClinicState;
    appointmentsSchedulerRef: any;
    routePath: any;
    selectedLanguage: any;
  };
  setState: Dispatch<SSBActionTypes>;
}) => {
  const { scheduledAppointments, recentlyBookedAppointments, stepsRef, selectedLanguage, appointmentsSchedulerRef } =
    context;

  // TODO: Avoid this call, this can be calculated before
  const fetchedSteps = await scheduleClient.getStepsForMember({
    clinicId: context.clinic!.details.clinicId,
    memberId: context.user!.id,
    programType: getEffectiveProgramType({ user: context.user, clinic: context.clinic }) as
      | ProgramType.InClinic
      | ProgramType.Remote,
    systemSource: capitalizeToKebabCase(context.user!.systemSource) as LeadSystemSource,
    schedulingWorkflow: SchedulingWorkflow.SelfServeBooking,
  });

  if (!fetchedSteps) {
    return Toast.notification(
      'error',
      'There was an error obtaining the information. Please reload the page or wait for a support member to contact you, we are looking for the solution.'
    );
  }

  // Reconcile with funnel-local memory: the backend's getStepsForMember response may still report
  // scheduled=false for an appointment we just booked, since the Acuity webhook may not have been
  // processed yet. reconcileStepsWithRecentBookings marks matching steps scheduled AND recomputes
  // the active step, so a just-booked step is never re-offered while the backend catches up.
  const recentKeys = Object.keys(recentlyBookedAppointments);
  const correctedSteps = reconcileStepsWithRecentBookings(fetchedSteps, recentKeys);

  context.stepsRef.current = correctedSteps;

  if (correctedSteps?.every((step) => step.scheduled || step.skipped)) {
    setState({ type: SET_SSB_INFO, payload: SSBFlowState.AllScheduled });
    return;
  }

  const previousAppointment = getPreviousAppointmentByRules({
    scheduledAppointments,
    stepsRef,
    selectedLanguage,
    calculatedSteps: correctedSteps,
  });

  appointmentsSchedulerRef.current?.resetCalendar(previousAppointment);

  setState({ type: SET_SSB_INFO, payload: SSBFlowState.InitSchedulingProcess });
};
